/* tslint:disable */
/* eslint-disable */

/**
 * Roman Swagger
 * Roman - Wire Bots Proxy
 *
 * The version of the OpenAPI document: 1.15.0
 * Contact: dejan@wire.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface RegistrationSuccessful
 */
export interface RegistrationSuccessful {
  /**
   *
   * @type {string}
   * @memberof RegistrationSuccessful
   */
  message: string;
}

export function RegistrationSuccessfulFromJSON(json: any): RegistrationSuccessful {
  return RegistrationSuccessfulFromJSONTyped(json, false);
}

export function RegistrationSuccessfulFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegistrationSuccessful {
  if ((json === undefined) || (json === null)) {
    return json;
  }
  return {

    'message': json['message'],
  };
}

export function RegistrationSuccessfulToJSON(value?: RegistrationSuccessful | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {

    'message': value.message,
  };
}


